module.exports = __webpack_public_path__ + "media/images/Pinterest-22eb2cf144197aeda3fd7f213768aa89.png";